import primary, {
  colors as baseColors,
  colorPalette as baseColorPalette,
  gradientConfettiPalette as baseGradientConfettiPalette,
} from './onedayonly';

const colorPalette = {
  ...baseColorPalette,
  giftVoucherYellow: '#E3AA01',
};

const colors = {
  ...baseColors,
  headerPrimary: colorPalette.giftVoucherYellow,
};

const gradientConfettiPalette = {
  ...baseGradientConfettiPalette,
  default: {
    start: '#FFC222',
    middle: '#FFC222',
    end: '#E3AA01',
    confetti: '#C3044F',
  },
};

const theme = {
  ...primary,
  name: 'giftvouchers',
  colors,
  colorPalette,
  gradientConfettiPalette,
};

Object.freeze(theme);

export default theme;
